import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RateStatsChartComponent } from './rate-stats-chart.component';
// import { NgxChartsModule } from '@swimlane/ngx-charts';

@NgModule({
    declarations: [RateStatsChartComponent],
    exports: [RateStatsChartComponent],
    imports: [CommonModule]
})
export class RateStatsChartModule {}
